import React, { useState } from 'react';
import { Card, Collapse } from 'react-bootstrap';

function CollapseIt({ blockCategoryVariantsBlocks, variantTitle }) {
  const [open, setOpen] = useState(true);
  let titleClass = 'collapsed';
  if (open) {
    titleClass = '';
  }
  return (
    <>
      <Card>
        <Card.Header>
          <Card.Title onClick={() => setOpen((prevOpen) => !prevOpen)}><a className={titleClass} href="#">{variantTitle}</a></Card.Title>
        </Card.Header>
        <Collapse in={open}>
          <Card.Body>{blockCategoryVariantsBlocks}</Card.Body>
        </Collapse>
      </Card>
    </>
  );
}
export default CollapseIt;
